// Central plan-tier registry. Every tier comparison in the frontend must go
// through these helpers so that higher tiers automatically inherit lower-tier
// capabilities (Base < Plus < Pass72 < PlusMAX < PlusMAX Pro).
// The delta codes MUST match backend_api/server.py.

export const BASE_USERLEVEL = '37485923';
export const PLUS_USERLEVEL = '497CC0000';
export const PASS72_USERLEVEL = '72A5E0D9C';
export const PLUSMAX_USERLEVEL = '11A5D7A0C';
export const PLUSMAX_PRO_USERLEVEL = '9F1D3B7EA';

const PLAN_RANKS = {
  [BASE_USERLEVEL]: 0,
  [PLUS_USERLEVEL]: 1,
  [PASS72_USERLEVEL]: 2,
  [PLUSMAX_USERLEVEL]: 3,
  [PLUSMAX_PRO_USERLEVEL]: 4
};

const deltaOf = (deltaOrDecoded) => {
  if (deltaOrDecoded && typeof deltaOrDecoded === 'object') {
    return String(deltaOrDecoded.delta || '');
  }
  return String(deltaOrDecoded || '');
};

export const planRank = (deltaOrDecoded) => {
  const delta = deltaOf(deltaOrDecoded);
  return Object.prototype.hasOwnProperty.call(PLAN_RANKS, delta) ? PLAN_RANKS[delta] : 0;
};

// Any paid tier at all (Plus, Pass72, PlusMAX, Pro).
export const isPremium = (deltaOrDecoded) => planRank(deltaOrDecoded) >= PLAN_RANKS[PLUS_USERLEVEL];

// Pass72-and-above: sale prices, repo markers/layer, flood, full stats panel.
export const hasPass72Access = (deltaOrDecoded) => planRank(deltaOrDecoded) >= PLAN_RANKS[PASS72_USERLEVEL];

// PlusMAX-and-above: buyer/seller names, CSV export, Karibe docs, LLM chat.
export const hasPlusMaxAccess = (deltaOrDecoded) => planRank(deltaOrDecoded) >= PLAN_RANKS[PLUSMAX_USERLEVEL];

// PlusMAX Pro only: PDF reports, saved areas + pulse, LLM analysis mode.
export const isPro = (deltaOrDecoded) => deltaOf(deltaOrDecoded) === PLUSMAX_PRO_USERLEVEL;

// Exactly the 72h pass (used for pass-specific messaging/expiry UI).
export const isPass72 = (deltaOrDecoded) => deltaOf(deltaOrDecoded) === PASS72_USERLEVEL;

// Display / analytics name for a tier.
export const planTierName = (deltaOrDecoded) => {
  const delta = deltaOf(deltaOrDecoded);
  if (delta === PLUSMAX_PRO_USERLEVEL) return 'PlusMAXPro';
  if (delta === PLUSMAX_USERLEVEL) return 'PlusMAX';
  if (delta === PASS72_USERLEVEL) return 'Pass72';
  if (delta === PLUS_USERLEVEL) return 'Plus';
  return 'Base';
};

const planTier = {
  BASE_USERLEVEL,
  PLUS_USERLEVEL,
  PASS72_USERLEVEL,
  PLUSMAX_USERLEVEL,
  PLUSMAX_PRO_USERLEVEL,
  planRank,
  isPremium,
  hasPass72Access,
  hasPlusMaxAccess,
  isPro,
  isPass72,
  planTierName
};

export default planTier;
